import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/data';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[480px] md:h-[620px] overflow-hidden">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.bgImage}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/55"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-[800px]">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
            {heroSlides[current].title}
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8">
            {heroSlides[current].subtitle}
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to={heroSlides[current].link}
              className="px-8 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即阅读
            </Link>
            <Link
              to="/category/anime"
              className="px-8 py-3 bg-white/20 backdrop-blur-sm text-white text-sm font-medium rounded-full hover:bg-white/30 transition-colors border border-white/30 whitespace-nowrap cursor-pointer"
            >
              探索更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === current ? 'bg-white w-6' : 'bg-white/50'
            }`}
            aria-label={`幻灯片 ${index + 1}`}
          />
        ))}
      </div>

      <div className="absolute bottom-6 right-6 flex items-center gap-2">
        <button
          onClick={() => setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 transition-colors cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-line text-white"></i>
        </button>
        <button
          onClick={() => setCurrent((prev) => (prev + 1) % heroSlides.length)}
          className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 transition-colors cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-line text-white"></i>
        </button>
      </div>
    </section>
  );
}